import { useCallback } from 'react';
import { Text } from '@adc/parallax-component-library';
import { LocalDate } from '@js-joda/core';
import { BirthdayInput, FormContainer, Input } from 'Components/utility';
import { useAccount } from 'Hooks';
import i18n from 'Utilities/i18n';

import { ContentContainer, type CreateAccountFormDefinition } from '../helpers';

type RegisterAccountFormProps = {
  formikForm: CreateAccountFormDefinition;
};

function RegisterAccountForm({ formikForm }: RegisterAccountFormProps) {
  const { validateDOBAndDisplayError } = useAccount();
  const { values, errors, touched, handleBlur, handleChange, setFieldTouched, setFieldValue } =
    formikForm;

  const handleDateChange = useCallback(
    (date: LocalDate, cancelled: boolean) => {
      setFieldTouched('dateOfBirth');

      if (cancelled) {
        return;
      }

      const dateString = date.toString();
      const isValid = validateDOBAndDisplayError(dateString);

      if (isValid) {
        setFieldValue('dateOfBirth', dateString);
      }
    },
    [setFieldValue, setFieldTouched, validateDOBAndDisplayError]
  );

  return (
    <ContentContainer>
      <Text>
        {i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.primaryText')}
      </Text>
      <FormContainer hasHiddenUserInput>
        <Input
          aria-label={i18n.t(
            'CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.firstName.label'
          )}
          placeholder={i18n.t(
            'CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.firstName.placeholder'
          )}
          label={i18n.t(
            'CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.firstName.label'
          )}
          testID="firstName"
          inputMode="text"
          errorMessage={errors.firstName}
          isInvalid={Boolean(errors.firstName && touched.firstName)}
          value={values.firstName}
          onChangeText={handleChange('firstName')}
          onBlur={handleBlur('firstName')}
        />
        <Input
          aria-label={i18n.t(
            'CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.lastName.label'
          )}
          placeholder={i18n.t(
            'CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.lastName.placeholder'
          )}
          label={i18n.t(
            'CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.lastName.label'
          )}
          testID="lastName"
          inputMode="text"
          errorMessage={errors.lastName}
          isInvalid={Boolean(errors.lastName && touched.lastName)}
          value={values.lastName}
          onChangeText={handleChange('lastName')}
          onBlur={handleBlur('lastName')}
        />
        <BirthdayInput
          error={!!errors.dateOfBirth}
          errorMessage={errors.dateOfBirth}
          isTouched={touched.dateOfBirth}
          initialDate={values.dateOfBirth ? LocalDate.parse(values.dateOfBirth) : undefined}
          onDateChange={handleDateChange}
          testID="dateOfBirth"
        />
      </FormContainer>
    </ContentContainer>
  );
}

export { RegisterAccountForm };
